<template>
  <div>
    <div class="form_content" :class="{ empty: isEmpty }">
      <div v-if="!isEmpty" class="row">
        <div
          class="col-md-6 col-xl-4 doc-card d-flex"
          v-for="(item, index) in fileList"
          :key="index"
        >
          <div class="doc-item p-2 flex-grow-1 d-flex flex-column">
            <div class="d-flex flex-grow-1">
              <div class="d-flex">
                <el-avatar
                  shape="square"
                  :size="40"
                  :src="item.fileIcon"
                  class="bg-transparent"
                />
              </div>
              <div class="flex-grow-1" style="width: calc(100% - 40px)">
                <div class="d-flex">
                  <div class="flex-grow-1 px-2 dic-name text-truncate">
                    {{ item.fileName }}
                  </div>
                  <div class="dic-size">{{ item.fileSize }}</div>
                </div>
                <div class="dic-desc px-2 mt-1 text-truncate">
                  {{ item.remark }}
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-end mt-1">
              <div class="d-flex align-items-center">
                <el-avatar :size="24" :src="item.memImgUrl">
                  <span>U</span>
                </el-avatar>
                <div class="ml-1 doc-modify">
                  <span>
                    {{ item.uploadByName }}
                  </span>
                  <span style="color: #8e8e8e; font-weight: 400">At:</span>
                  <span>{{ item.modifyTime }}</span>
                </div>
              </div>
              <div class="doc-opts">
                <i class="el-icon-view tool-btn" @click="view(item)" />
                <i class="el-icon-download tool-btn" @click="download(item)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'dayjs/locale/zh-cn'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)
import { request } from '@/api/service'
export default {
  components: {},
  props: {
    tskInfoDocList: { type: Array, default: () => [] },
    fileIcons: { type: Object, default: () => {}},
  },
  data() {
    return {
      loading: false,
      fileList: [],
    }
  },
  computed: {
    isEmpty() {
      return !this.tskInfoDocList?.length
    },
  },

  watch: {
    tskInfoDocList: {
      handler(e) {
        if (!e || !e.length) return
        this.fileList = e.map((item) => {
          const { fileName, uploadLocalTime } = item
          return {
            ...item,
            fileIcon: this.getFileIcon(fileName),
            modifyTime: dayjs(uploadLocalTime).locale('zh-cn').fromNow(),
          }
        })
      },
      immediate: true,
    },
  },

  async mounted() {
  },
  methods: {

    getFileIcon(fileName) {
      const getFileType = (filename) => {
        if (!filename) return ''
        if (!filename.includes('.')) return ''
        return filename.split('.').pop()
      }
      const fileType = getFileType(fileName) || 'OTHER'

      return this.$osscdn(
        this.fileIcons[fileType.toUpperCase()] || this.fileIcons['OTHER']
      )
    },

    view({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode, { isAutoDown: true, preview: true })
    },
    download({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
  },
}
</script>

<style lang="scss" scoped>
.form_content.empty {
  border: 1px dashed #bbbbbb;
  border-radius: 5px;
  padding: 20px;
  margin-top: 10px;
}
.empty-content {
  text-align: center;
  flex: 1;
  p {
    font-size: 13px;
    color: #606266;
    margin-top: 10px;
    margin-bottom: 0;
  }
}

.row {
  margin-right: -5px;
  margin-left: -5px;
  .col-md-6.col-xl-4 {
    padding-right: 5px;
    padding-left: 5px;
  }
}

.doc-card {
  margin-top: 10px;
  .doc-item {
    border: 1px dashed #bbbbbb;
    border-radius: 5px;
    max-width: 100%;
    .dic-name {
      font-size: 14px;
      color: #007bff;
      word-break: break-all;
    }
    .dic-size {
      font-size: 14px;
      color: #6c757d;
      font-weight: 500;
      min-width: max-content;
    }
    .dic-desc {
      font-size: 12px;
      color: #8e8e8e;
      word-break: break-all;
    }
    .doc-modify {
      font-size: 12px;
      color: #6c757d;
      font-weight: 500;
      span {
        margin-right: 5px;
      }
    }
    .doc-opts {
      color: #bbbbbb;
      min-width: max-content;
    }
  }
}
</style>
